module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_36.8a8458ad.jpg";